import { render, staticRenderFns } from "./TrackComments.vue?vue&type=template&id=f551bdfa&scoped=true"
import script from "./TrackComments.vue?vue&type=script&lang=js"
export * from "./TrackComments.vue?vue&type=script&lang=js"
import style0 from "./TrackComments.vue?vue&type=style&index=0&id=f551bdfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f551bdfa",
  null
  
)

export default component.exports